import { Environment } from '@common/models/Enums';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import React from 'react';

export const EnvironmentWarning = observer(
  (props: { isForHeader?: boolean }) => {
    const env = appEnv.ENV as Environment;
    let envClass = '';
    switch (env) {
      case Environment.local:
        envClass = 'env-local';
      case Environment.alpha:
        envClass = 'env-alpha';
      case Environment.dev:
        envClass = 'env-dev';
      case Environment.test:
        envClass = 'env-test';
      case Environment.feature:
        envClass = 'env-feature';
      case Environment.training:
        envClass = 'env-training';
        return props.isForHeader ? (
          <div className={classNames('env-warning header', envClass)}>
            DEV-TRAINING ONLY
          </div>
        ) : (
          <div className={classNames('env-warning', envClass)}>
            STOP: THIS IS A DEVELOPMENT-TRAINING SITE ONLY, DO NOT ENTER LIVE
            CUSTOMER OR HOSPITAL DATA HERE.
          </div>
        );
      default:
        envClass = 'env-prod';
        return <span className={envClass}> </span>;
    }
  },
);
